import { getBaseMetaTitle } from '@/environments'

const Contact = () => import('./Main')

const route = {
  path: '/contact',
  name: 'contact',
  meta: {
    title: `Contact - ${getBaseMetaTitle}`
  },
  component: Contact
}

export default route
